// Component for group of radios
import * as React from "react";
import { useTranslation } from "react-i18next";
import { TierContext } from "tiers/context";
const TIER_VALUE_PLACEHOLDER = "____LOCKED_ITEM____";
export const Select = (props) => {
    var _a;
    const tiers = React.useContext(TierContext);
    const { t } = useTranslation();
    function onChange(e) {
        if (e.target.value === TIER_VALUE_PLACEHOLDER) {
            tiers.popup(`PP:${props.id}`);
            return;
        }
        props.onSelectChange(props.value, e.target.value);
    }
    return React.createElement("select", { className: "custom-select " + ((_a = props.extraClass) !== null && _a !== void 0 ? _a : ""), id: props.id, value: props.value, onChange: e => onChange(e) }, props.options.map((o) => {
        const label = t(["props." + o.label, "ui." + o.label, o.label], o.label);
        return tiers.allow(o) ?
            React.createElement("option", { key: o.value, value: o.value }, label)
            : React.createElement("option", { key: o.value, value: TIER_VALUE_PLACEHOLDER },
                label,
                " - \u26A1");
    }));
};
